
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({ components: {} })
export default class DialogDISC extends Vue {
  @Prop() onClick!: Function;
}
